import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";
import { ContentItemRender } from "~/components/content/content-item-render";

export const StyledContentItemRender = styled(ContentItemRender)``;

export const Container = styled.div``;

export const Title = styled(BaseLink)`
  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: 15px;
`;

export const Content = styled.div`
  margin-block-start: 12px;

  overflow: hidden;

  & > *:not(:last-child) {
    margin-block-end: 12px;
    padding-block-end: 12px;

    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  }
`;
